import React from 'react';

import {useTheme} from '@mui/material';
import {Trans, useTranslation} from 'react-i18next';

import {
  PolicyTermsContainer, StyledLink,
} from './Style.js';

/**
 * Policy Terms Component -
 * @return {ReactElement}
 */
export default function PolicyTerms() {
  const theme = useTheme();
  const {t} = useTranslation();

  return (
    <PolicyTermsContainer
      container direction="row"
      justifyContent="center"
    >
      <div
        style={{
          textAlign: 'center',
          fontSize: '12px',
          fontWeight: 400,
          color: theme.palette.text.tertiary,
        }}
      >
        <Trans
          i18nKey="booking.policyTerms"
          defaults={t('booking.policyTerms')}
          components={{
            policyLink: <StyledLink
              target="_blank"
              tabIndex={1}
              href="https://policies.google.com/privacy"
            />,
            termsLink: <StyledLink
              target="_blank"
              tabIndex={1}
              href="https://policies.google.com/terms"
            />,
          }}
        />
      </div>
    </PolicyTermsContainer>
  );
}
